import { render } from "./NotificationsMessage.vue?vue&type=template&id=53734412&scoped=true"
import script from "./NotificationsMessage.vue?vue&type=script&lang=js"
export * from "./NotificationsMessage.vue?vue&type=script&lang=js"

import "./NotificationsMessage.vue?vue&type=style&index=0&id=53734412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53734412"]])

export default __exports__